<div class="maintenance-page">
  <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.main-tv-shop-header'"></app-tvshop-header>
  <div class="maintenance-container">
    <figure></figure>
    <h2 class="title" [translate]="'eos-tv-shop-ii.title.info-maintenance'"></h2>
    <div class="description" [translate]="'eos-tv-shop-ii.text.info-maintenance'"
         [translateParams]="{ endDayName: endDayName, endDayHour: endDayHour, endDayMinutes: endDayMinutes }">
    </div>
  </div>

</div>
